var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	53858: {
		fallback: () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	58750: {
		fallback: () => (__webpack_require__.e(677).then(() => (() => (__webpack_require__(57058))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.9.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",

	},
	93888: {
		fallback: () => (__webpack_require__.e(950).then(() => (() => (__webpack_require__(97950))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	50927: {
		fallback: () => (__webpack_require__.e(730).then(() => (() => (__webpack_require__(37730))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.9.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mui/material",

	},
	74995: {
		fallback: () => (__webpack_require__.e(664).then(() => (() => (__webpack_require__(61664))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.3.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"87": [
		50927,
		74995
	],
	"858": [
		53858
	],
	"933": [
		58750,
		93888
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}